import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["crm-lifecycle"]!.en!;

export const Route = createFileRoute("/en/services/crm-lifecycle")({
  head: () =>
    pageHead({
      path: "/en/services/crm-lifecycle",
      title: c.title,
      description: c.description,
      crumbs: [["Services", "/services"], ["CRM & Lifecycle", "/en/services/crm-lifecycle"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="crm-lifecycle" forceLanguage="en" pathOverride="/en/services/crm-lifecycle" />,
});
